namespace advisorop.components.servicer {


    class CuAdvisoryFirmController {
        $router;
        onUpdateAdvisoryFirm: any;
        onCreateAdvisoryFirm: any;
        advisoryFirmId: number;

        selAdvisoryFirm: domains.IAdvisoryFirm;
        model: domains.IAdvisoryFirm;

        isInEditState: boolean = false;

        static $inject=["servicerService", "advisoryFirmApi"]
        constructor(private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {
        }


        createAdvisoryFirm(): void {
            this.advisoryFirmApi.create(this.model)
                .then(data => {

                    this.model = data.data;
                    toastr.success("Advisory firm created.");

                    this.onCreateAdvisoryFirm({ advisoryFirm: this.model });

                })
                .catch(err => { toastr.error("Cannot create advisory firm."); });
        }


        updateAdvisoryFirm(): void {
            this.advisoryFirmApi.update(this.model)
                .then(data => {
                    this.model = data.data;
                    toastr.success("Advisory firm updated.");
                    this.onUpdateAdvisoryFirm({ advisoryFirm: this.model });

                })
                .catch(err => { toastr.error("Cannot update advisory firm."); });
        }


        loadAdvisoryFirmData(companyId: number): void {
            this.servicerService.getCompanyGroup(companyId)
                .then(data => {
                    this.model = data.data;
                })
                .catch(err => { toastr.error("Cannot fetch advisory firm.") })
        }

        createEvent: boolean = false;

        $onInit(): void {

        };

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "advisoryFirmId") {
                    if (this.advisoryFirmId > 0) {
                        this.loadAdvisoryFirmData(this.advisoryFirmId);
                    }
                }
                if (key === "createEvent") {
                    this.createEvent = this.createEvent;
                }

            }
        }

    }

    class CuAdvisoryFirm implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "router": "<",
                advisoryFirmId: "<",
                onUpdateAdvisoryFirm: "&",
                onCreateAdvisoryFirm: "&",
                createEvent: "<"
            };
            this.controller = CuAdvisoryFirmController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/cu-advisory-firm.html';
        }
    }
    angular.module(Constants.APP).component("cuAdvisoryFirm", new CuAdvisoryFirm());
}